/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Hero_LedeInputs */

const en_blog_hero_lede = /** @type {(inputs: Blog_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training, nutrition and recovery, explained by the coaches who do it every day.`)
};

const pl_blog_hero_lede = /** @type {(inputs: Blog_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening, dieta i regeneracja wyjaśnione przez trenerów, którzy robią to na co dzień.`)
};

/**
* | output |
* | --- |
* | "Training, nutrition and recovery, explained by the coaches who do it every day." |
*
* @param {Blog_Hero_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_hero_lede = /** @type {((inputs?: Blog_Hero_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Hero_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_hero_lede(inputs)
	return en_blog_hero_lede(inputs)
});